import SessionModel from "../api/models/SessionModel";
import {
  getSessionsFromScheduleSlots,
  removeDuplicatedScheduledSessions,
} from "../components/sessions/helper";
import CalendarScheduleSlotModel from "../models/CalendarScheduleSlotModel";

export abstract class ActiveSessionsService {
  protected sessions: SessionModel[];
  protected scheduleSlotsSessions: SessionModel[];

  constructor(sessions: SessionModel[], slots: CalendarScheduleSlotModel[]) {
    this.sessions = sessions;
    this.scheduleSlotsSessions = removeDuplicatedScheduledSessions(
      sessions,
      getSessionsFromScheduleSlots(slots)
    );
  }

  abstract generateActiveSessions(sessionsCount: number): SessionModel[];
}
